import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';
/* eslint-disable */
import './index/hotel.css';
import '@/css/desktop/tooltip.scss';
import "./index/pageTopBlock/mentionsBlock/mentionsBlock.css";
import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";
import HotelPageView from './index/HotelPageDistributed';
import HotelPageGalleryView from './index/pageTopBlock/gallery/gallery';
import HotelPageReviewsView from './index/reviews/HotelPageReviews';
import hotelPageGAEventsView from "@/js/desktop/components/hotelPageGAEvents/hotelPageGAEvents";
import getTopHotelsAvailable from '@/js/common/services/getTopHotelsAvailable';
import { initAdModal } from '@/js/common/services/promoService';

var Controller = Backbone.View.extend({
	view: null,
	initModels: function() {
		this.dataLayerAnalytics = new DataLayerAnalytics({
			step: "hotelPage",
			maxStep: 2
		});

		this.view = new HotelPageView({
			el: 'body',
			hotelInfo: window.appConfig.hotelInfo,
			dataLayerAnalytics: this.dataLayerAnalytics
		});

		HotelPageGalleryView.init();

		$(".similar-hotel__carousel").jsCarousel();
		new HotelPageReviewsView();

		hotelPageGAEventsView.init();
	},
	hideTopHotels() {
		const isTopHotelAvailble = getTopHotelsAvailable();
		if (isTopHotelAvailble) return;

		const topHotelsBlock = document.querySelector('.mentionsBlock');
		if(topHotelsBlock) {
			topHotelsBlock.style.display = 'none';
		}

	},
	initialize: function() {
		this.initModels();
		this.hideTopHotels();
		initAdModal();
    },
});

$(()=> {
	new Controller({
		el: 'body'
	});
});
